<template>
    <div class="row">
        <form @submit.prevent="currentEvent ? updateEvent() : addNewEvent()">
            <div class="panel panel-primary">
                <div class="panel-heading">Add New Event</div>
                <div class="panel-body" v-if="form">
                    <div class="form-group row">
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>Name</label>
                            <input class="form-control" v-model="form.club_event_name" placeholder="Club Event Name" />
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>Start Date</label>
                            <datepicker placeholder="Start Date" v-model="form.plain_start_date" dateformat="DD/MM/YYYY"></datepicker>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>End Date</label>
                            <datepicker placeholder="End Date" v-model="form.plain_end_date" dateformat="DD/MM/YYYY"></datepicker>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>Requires Volunteers</label><br>
                            <input type="checkbox" class="form-control" v-model="form.requires_volunteers">
                        </div>
                    </div>
                    <div class="form-group row">
                        <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
                            <label>Type</label>
                            <select class="form-control chosen-select" v-model="form.event_type">
                                <option value="Open Meet">Open Meet</option>
                                <option value="Away Meet">Away Meet</option>
                                <option value="Social Event">Social Event</option>
								<option value="League Event">League Event</option>
								<option value="Time Trials">Time Trials</option>
								<option value="Club Championships">Club Championships</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="panel-footer">
                    <button type="submit" class="btn btn-success pull-right">{{ buttonLabel }}</button>
                    <div class="clearfix"></div>
                </div>
            </div>
        </form>
    </div>
</div>
</template>

<script>
    import Form from '../utils/Form';

    export default {
        props: [
            'currentEvent'
        ],

        data: function () {
            return {
                form: new Form({
                    club_event_name: this.currentEvent ? this.currentEvent.club_event_name : null,
                    plain_start_date: this.currentEvent ? this.formatDate(this.currentEvent.start_date) : null,
                    plain_end_date: this.currentEvent ? this.formatDate(this.currentEvent.end_date) : null,
                    start_date: this.currentEvent ? this.currentEvent.start_date : null,
                    end_date: this.currentEvent ? this.currentEvent.end_date : null,
                    requires_volunteers: this.currentEvent ? this.currentEvent.requires_volunteers : true,
                    event_type: this.currentEvent ? this.currentEvent.event_type : null
                }),
                buttonLabel: this.currentEvent ? 'Update Event' : 'Save New Event'
            };
        },

        methods: {
            addNewEvent() {
                this.formatDatabaseDate();

                this.form.post('/api/v1/club_events')
                    .then(response => {
                        this.$emit('event-changed');
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the event.', type: 'error'});
                    });
            },

            updateEvent() {
                this.formatDatabaseDate();

                this.form.put(`/api/v1/club_events/${this.currentEvent.id}`)
                    .then(response => {
                        this.$emit('event-changed');
                    })
                    .catch(error => {
                        this.$message({message: 'There was a problem saving the event.', type: 'error'});
                    });
            },

            formatDate(theDate) {
                return moment(theDate).format("DD/MM/YYYY");
            },

            formatDatabaseDate() {
                this.form.start_date = moment(this.form.plain_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm:ss');
                this.form.end_date = moment(this.form.plain_end_date, 'DD/MM/YYYY').format('YYYY-MM-DD HH:mm:ss');
            }
        },

        destroyed() {
            this.form = null;
        }
    }
</script>
